import { render, staticRenderFns } from "./uptos3-video.vue?vue&type=template&id=753693e5&"
import script from "./uptos3-video.vue?vue&type=script&lang=js&"
export * from "./uptos3-video.vue?vue&type=script&lang=js&"
import style0 from "./uptos3-video.vue?vue&type=style&index=0&id=753693e5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports